import React from 'react';
import { FilteredActivityFeedTypes } from '@components/Feed/store';
import { useActivityFeed } from '@components/Feed/useActivityFeed';
import { LandingHeading } from '@components/Landing/shared/LandingHeading';
import { useCreatePost } from '@hooks/useCreatePost';
import { NAV_LINKS } from '@utils/constants';

export const Heading = () => {
  const { onCreatePostClick } = useCreatePost({ onCreate: null });
  const { setActivityFeedFilter } = useActivityFeed({
    disabled: true,
  });

  const setTrendingPostsFilter = () => {
    setActivityFeedFilter(FilteredActivityFeedTypes.Global);
  };

  return (
    <LandingHeading
      header="Trending Posts"
      pathnameUri={NAV_LINKS.Feed}
      onHeaderClick={setTrendingPostsFilter}
      onCreateClicked={onCreatePostClick}
    />
  );
};
